import { render, staticRenderFns } from "./CertificationEvidenceReminderModal.vue?vue&type=template&id=2d22c8f7&scoped=true"
import script from "./CertificationEvidenceReminderModal.vue?vue&type=script&lang=js"
export * from "./CertificationEvidenceReminderModal.vue?vue&type=script&lang=js"
import style0 from "./CertificationEvidenceReminderModal.vue?vue&type=style&index=0&id=2d22c8f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22c8f7",
  null
  
)

export default component.exports